import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterByName',
    pure: false
})
export class FilterByNamePipe implements PipeTransform {
    transform(items: any[], searchText: string): any {
        
        if (!items || !searchText) {
            return items;
        }

        return items.filter(it => {
            return it.fullName.toLowerCase().includes(searchText.toLowerCase());
        });

        
    }
}